import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const SelectInputWrapper = styled.div`
  display: block;

  label {
    font-family: "Roboto Mono",
    display: block;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 300;
    color: #7f7f7f;
    margin: 30px 0 10px;
  }

  > div {
    display: flex;
    flex: 1 1 0;
  }
`;

const SelectInputButton = styled.button`
  background: #2d2e30;
  flex: 100%;
  border: none;
  /* border-right: 1px solid black; */
  height: 60px;
  cursor: pointer;
  color: #8f9092;
  text-transform: uppercase;
  font-size: 14px;

  &:focus,
  &:active {
    outline: none;
  }

  ${props => {
    if (props.size === "small") {
      return css`
        background: #eceef2;
        color: #7f7f7f;
        height: 37px;
        padding: 0 15px;
      `;
    }
  }};
  ${props => {
    if (props.active) {
      return css`
        cursor: default;
        background: #ff5000;
        color: #fff;
      `;
    }
  }};
`;

const SelectInput = ({ onChange, name, title, selected, selectData, size }) => {
  const onClick = buttonId => {
    onChange(name, _.isNumber(buttonId) ? _.parseInt(buttonId) : buttonId);
  };

  return (
    <SelectInputWrapper size={size}>
      {title && <label>{title}</label>}
      <div>
        {selectData.map(item => (
          <SelectInputButton
            active={selected === (_.isNumber(item) ? _.parseInt(item) : item)}
            key={item}
            onClick={onClick.bind(null, item)}
            size={size}
          >
            {item}
          </SelectInputButton>
        ))}
      </div>
    </SelectInputWrapper>
  );
};

SelectInput.defaultProps = {
  selectData: [],
  size: "large"
};

SelectInput.propTypes = {
  selectData: PropTypes.arrayOf(PropTypes.string.isRequired),
  size: PropTypes.string
};

export default SelectInput;
